export enum BillingActions {
  UPGRADE_TO_PRO = 'upgrade_to_pro',
  UPDATE_CREDENTIALS = 'update_credentials',
  BACK_TO_PRO = 'back_to_pro',
  RENEW_SUBSCRIPTION = 'renew_subscription',
  NONE = 'none',
}
